import ageGroupsDataEn from "./ageGroupsDataEn";
import ageGroupsDataEs from "./ageGroupsDataEs";

const ageGroupsData = process.env.REACT_APP_LANGUAGE === 'es' ? ageGroupsDataEs : ageGroupsDataEn;
export default ageGroupsData;